















import { Component, Vue, Prop } from "vue-property-decorator";
import PostcodeArgs from "../components/JobSearches/PostcodeArgs.vue";
import UpcomingJob from "../components/JobSearches/UpcomingJob.vue";
import { JobItem } from "../common/interfaces";
import Store from "@/store/store";
import axios from "axios";
import moment from "moment";

@Component({
  components: {
    PostcodeArgs,
    UpcomingJob
  }
})
export default class ByPostcode extends Vue {
  protected jobs: JobItem[] = [];
  protected loadingJobs: boolean = false;
  protected postcode: string = "";
  protected radius: number = 10;

  public created() {
    this.postcode = this.$route.params.postcode;
  }

  public async search() {
    this.loadingJobs = true;
    this.jobs = [];

    const response = await axios.get(
      `${Store.state.Environment.ODataBaseUrl}/Problems/?` +
        `$select=ProblemId,Description,Type1Id,StatusId,StatusFlag` +
        `&$expand=ProblemXtra($select=EngineerCode,BookedInDateTime,ExamDueDate),` +
        `Contact($select=ContactId;$expand=Division($select=Name;$expand=Company($select=Name)),` +
        `Address($select=AddressLine4,Postcode)),` +
        `Inventory($select=InventoryId;$expand=InventoryXtra($select=NextVisitDate)` +
        `,Division($select=DivisionId,Name;$expand=Address($select=AddressId,Postcode,AddressLine4;$expand=PostcodeSearch($select=DistanceMiles))` +
        `,Company($select=CompanyId,Name)))` +
        `,Type1($select=Description)` +
        `&$filter=StatusId eq 'ENGINR' and StatusFlag eq 'A' and ProblemXtra/EngineerCode eq '${Store.state.User.UserCode}' and Inventory/Division/Address/PostcodeSearch/Outcode ne null
                &$orderby=Inventory/Division/Address/PostcodeSearch/DistanceMiles`,
      {
        headers: {
          Authorization: "Bearer " + Store.state.User.AccessToken,
          "x-conn-1": this.postcode,
          "x-conn-2": this.radius
        }
      }
    );

    if (response.status === 200 && response.data) {
      const jobs = response.data.value;
      jobs.forEach((j: any) => {
        const job: JobItem = {
          JobId: j.ProblemId,
          JobDescription: j.Description,
          JobType: j.Type1Id,
          TypeDescription: j.Type1.Description,
          StatusId: j.StatusId,
          StatusFlag: j.StatusFlag,
          EngineerCode: j.ProblemXtra.EngineerCode,
          DueDate: moment(j.ProblemXtra.ExamDueDate),
          BookedInDateTime: j.ProblemXtra.BookedInDateTime
            ? moment(j.ProblemXtra.BookedInDateTime)
            : undefined,
          DivisionName: j.Inventory ? j.Inventory.Division.Name : null,
          CompanyName: j.Inventory ? j.Inventory.Division.Company.Name : null,
          AddressPostcode: j.Inventory ? j.Inventory.Division.Address.Postcode : null,
          NextVisitDate: moment(j.Inventory.InventoryXtra.NextVisitDate),
          Distance: j.Inventory
            ? j.Inventory.Division.Address.PostcodeSearch.DistanceMiles
            : null
        };

        this.jobs.push(job);
      });
    } else {
      // tslint:disable-next-line:no-console
      console.error(response);
      this.$notify.error({
        title: "Error",
        message: "Search failed",
        offset: 48
      });
    }

    this.loadingJobs = false;
  }

  private updatePostcode(newValue: string) {
    this.postcode = newValue;
  }

  private updatedRadius(newValue: number) {
    this.radius = newValue;
  }
}
